import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Teleport as _Teleport, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "measurements-selector__meta-information" }
const _hoisted_2 = {
  key: 0,
  class: "measurements-selector__product-price-total"
}
const _hoisted_3 = { class: "measurements-selector__product-price measurements-selector__product-price--large" }
const _hoisted_4 = {
  key: 0,
  class: "icon icon-spinner2"
}
const _hoisted_5 = { class: "measurements-selector__price measurements-selector__product-price--small" }
const _hoisted_6 = {
  key: 0,
  class: "icon icon-spinner2"
}
const _hoisted_7 = { class: "measurements-selector__price-structure" }
const _hoisted_8 = { class: "measurements-selector__price-structure-nav" }
const _hoisted_9 = { class: "btn__icon" }
const _hoisted_10 = { class: "btn__text" }
const _hoisted_11 = { class: "measurements-selector__save-and-share" }
const _hoisted_12 = { class: "measurements-selector__save-and-share" }
const _hoisted_13 = ["aria-hidden"]
const _hoisted_14 = {
  key: 0,
  class: "measurements-selector__pricing-table"
}
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = {
  key: 2,
  class: "measurements-selector__pricing-table__addition"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_21 = [
  _hoisted_18,
  _hoisted_19,
  _hoisted_20
]
const _hoisted_22 = { key: 3 }
const _hoisted_23 = { key: 4 }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_25 = {
  key: 5,
  class: "measurements-selector__pricing-table__addition"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("td", null, null, -1)
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { key: 6 }
const _hoisted_31 = {
  key: 1,
  class: "measurements-selector__pricing-table"
}
const _hoisted_32 = { class: "measurements-selector__pricing-section" }
const _hoisted_33 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormattedPrice = _resolveComponent("FormattedPrice")!
  const _component_ChevronRightIcon = _resolveComponent("ChevronRightIcon")!
  const _component_StoreButton = _resolveComponent("StoreButton")!
  const _component_StoreModal = _resolveComponent("StoreModal")!
  const _component_ShareButton = _resolveComponent("ShareButton")!
  const _component_ShareModal = _resolveComponent("ShareModal")!
  const _component_PriceStructureComponent = _resolveComponent("PriceStructureComponent")!
  const _component_measurements_height_transition = _resolveComponent("measurements-height-transition")!
  const _component_BulkPriceTable = _resolveComponent("BulkPriceTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createBlock(_Teleport, { to: "#measurements-selector-pricing-table" }, [
      ($props.isShapeComplete || $options.shouldShowSpinner)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              ($options.shouldShowSpinner)
                ? (_openBlock(), _createElementBlock("i", _hoisted_4))
                : (_openBlock(), _createBlock(_component_FormattedPrice, {
                    key: 1,
                    price: $options.totalPriceIncVat,
                    dataTestID: "product_action_bar_price_incl"
                  }, null, 8, ["price"]))
            ]),
            _createElementVNode("div", _hoisted_5, [
              ($options.shouldShowSpinner)
                ? (_openBlock(), _createElementBlock("i", _hoisted_6))
                : (_openBlock(), _createBlock(_component_FormattedPrice, {
                    key: 1,
                    price: $options.totalPriceExVat,
                    dataTestID: "product_action_bar_price_excl"
                  }, null, 8, ["price"])),
              _createTextVNode(" " + _toDisplayString($options.i18n.vatExcluded), 1)
            ])
          ]))
        : _createCommentVNode("", true)
    ])),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("ul", _hoisted_8, [
        _createElementVNode("li", {
          class: _normalizeClass(["measurements-selector__price-structure-nav-item", { 'measurements-selector__price-structure-nav-item--active': _ctx.showPriceStructure }])
        }, [
          ($props.isShapeComplete)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "btn btn--extra-small btn--clean-link btn--clean-icon",
                type: "button",
                onClick: _cache[0] || (_cache[0] = ($event: any) => {_ctx.showPriceStructure = ! _ctx.showPriceStructure; $options.addDataLayerEvent()})
              }, [
                _createElementVNode("span", _hoisted_9, [
                  _createVNode(_component_ChevronRightIcon, {
                    class: "icon-inline icon-inline--expanded svg-icon-chevron-right-icon",
                    "aria-hidden": "true"
                  })
                ]),
                _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.showPriceStructure ? $options.i18n.meta.hidePriceStructure : $options.i18n.meta.showPriceStructure), 1)
              ]))
            : _createCommentVNode("", true)
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["measurements-selector__price-structure-nav-item", { 'measurements-selector__price-structure-nav-item--faded': _ctx.showPriceStructure }])
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_StoreButton),
            _createVNode(_component_StoreModal)
          ])
        ], 2),
        _createElementVNode("li", {
          class: _normalizeClass(["measurements-selector__price-structure-nav-item", { 'measurements-selector__price-structure-nav-item--faded': _ctx.showPriceStructure }])
        }, [
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_ShareButton),
            _createVNode(_component_ShareModal)
          ])
        ], 2)
      ]),
      _createVNode(_component_measurements_height_transition, {
        appear: "",
        mode: "out-in"
      }, {
        default: _withCtx(() => [
          _withDirectives(_createElementVNode("div", {
            class: "measurements-selector__pricing",
            "aria-hidden": !_ctx.showPriceStructure
          }, [
            ($props.isShapeComplete || $options.shouldShowSpinner)
              ? (_openBlock(), _createElementBlock("table", _hoisted_14, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, _toDisplayString($options.i18n.meta.materialPrice), 1),
                      _createVNode(_component_PriceStructureComponent, {
                        price: $options.pricesIncVat.material,
                        isEx: false,
                        showSpinner: $options.shouldShowSpinner
                      }, null, 8, ["price", "showSpinner"]),
                      _createVNode(_component_PriceStructureComponent, {
                        price: $options.pricesExVat.material,
                        isEx: true,
                        showSpinner: $options.shouldShowSpinner
                      }, null, 8, ["price", "showSpinner"])
                    ]),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, _toDisplayString($options.i18n.meta.sawingCosts), 1),
                      _createVNode(_component_PriceStructureComponent, {
                        price: $options.pricesIncVat.sawing,
                        isEx: false,
                        showSpinner: $options.shouldShowSpinner
                      }, null, 8, ["price", "showSpinner"]),
                      _createVNode(_component_PriceStructureComponent, {
                        price: $options.pricesExVat.sawing,
                        isEx: true,
                        showSpinner: $options.shouldShowSpinner
                      }, null, 8, ["price", "showSpinner"])
                    ]),
                    ($options.showMinimumFee)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_15, [
                          _createElementVNode("td", null, _toDisplayString($options.i18n.meta.minimumPriceFee), 1),
                          _createVNode(_component_PriceStructureComponent, {
                            price: $options.pricesIncVat.minimumPriceFee,
                            isEx: false,
                            showSpinner: $options.shouldShowSpinner
                          }, null, 8, ["price", "showSpinner"]),
                          _createVNode(_component_PriceStructureComponent, {
                            price: $options.pricesExVat.minimumPriceFee,
                            isEx: true,
                            showSpinner: $options.shouldShowSpinner
                          }, null, 8, ["price", "showSpinner"])
                        ]))
                      : _createCommentVNode("", true),
                    ($options.showBulkPrice && $options.pricesIncVat.bulkDiscount > 0)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_16, [
                          _createElementVNode("td", null, _toDisplayString($options.i18n.meta.bulkDiscount), 1),
                          _createVNode(_component_PriceStructureComponent, {
                            price: -1 * $options.pricesIncVat.bulkDiscount,
                            isEx: false,
                            showSpinner: $options.shouldShowSpinner
                          }, null, 8, ["price", "showSpinner"]),
                          _createVNode(_component_PriceStructureComponent, {
                            price: -1 * $options.pricesExVat.bulkDiscount,
                            isEx: true,
                            showSpinner: $options.shouldShowSpinner
                          }, null, 8, ["price", "showSpinner"])
                        ]))
                      : _createCommentVNode("", true),
                    ($options.showComplexStructure)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_17, _hoisted_21))
                      : _createCommentVNode("", true),
                    ($options.showComplexStructure)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_22, [
                          _createElementVNode("td", null, _toDisplayString($options.i18n.meta.unitPrice), 1),
                          _createVNode(_component_PriceStructureComponent, {
                            price: $options.pricesIncVat.bulkUnitPrice,
                            isEx: false,
                            showSpinner: $options.shouldShowSpinner
                          }, null, 8, ["price", "showSpinner"]),
                          _createVNode(_component_PriceStructureComponent, {
                            price: $options.pricesExVat.bulkUnitPrice,
                            isEx: true,
                            showSpinner: $options.shouldShowSpinner
                          }, null, 8, ["price", "showSpinner"])
                        ]))
                      : _createCommentVNode("", true),
                    ($options.showComplexStructure)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_23, [
                          _hoisted_24,
                          _createElementVNode("td", null, "x " + _toDisplayString(_ctx.quantity), 1),
                          _createElementVNode("td", null, "x " + _toDisplayString(_ctx.quantity), 1)
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", null, _toDisplayString($options.i18n.meta.shapeFee), 1),
                      _createVNode(_component_PriceStructureComponent, {
                        price: $options.pricesIncVat.fee,
                        isEx: false,
                        showSpinner: $options.shouldShowSpinner
                      }, null, 8, ["price", "showSpinner"]),
                      _createVNode(_component_PriceStructureComponent, {
                        price: $options.pricesExVat.fee,
                        isEx: true,
                        showSpinner: $options.shouldShowSpinner
                      }, null, 8, ["price", "showSpinner"])
                    ]),
                    ($options.showComplexStructure)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_25, _hoisted_29))
                      : _createCommentVNode("", true),
                    ($options.showComplexStructure)
                      ? (_openBlock(), _createElementBlock("tr", _hoisted_30, [
                          _createElementVNode("td", null, _toDisplayString($options.i18n.meta.total), 1),
                          _createVNode(_component_PriceStructureComponent, {
                            price: $options.totalPriceIncVat,
                            isEx: false,
                            showSpinner: $options.shouldShowSpinner
                          }, null, 8, ["price", "showSpinner"]),
                          _createVNode(_component_PriceStructureComponent, {
                            price: $options.totalPriceExVat,
                            isEx: true,
                            showSpinner: $options.shouldShowSpinner
                          }, null, 8, ["price", "showSpinner"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ]))
              : (_openBlock(), _createElementBlock("table", _hoisted_31, [
                  _createElementVNode("tbody", null, [
                    _createElementVNode("tr", null, [
                      _createElementVNode("td", _hoisted_32, [
                        _createElementVNode("strong", null, _toDisplayString($options.translatedShapeName), 1)
                      ])
                    ])
                  ])
                ]))
          ], 8, _hoisted_13), [
            [_vShow, _ctx.showPriceStructure]
          ])
        ]),
        _: 1
      })
    ]),
    (_openBlock(), _createBlock(_Teleport, { to: "#measurements-selector-availability" }, [
      ($props.availability)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "measurements-selector__availability",
            innerHTML: $props.availability
          }, null, 8, _hoisted_33))
        : _createCommentVNode("", true)
    ])),
    _createVNode(_component_BulkPriceTable, {
      price: $options.originalPriceExVat,
      shape: $props.shape,
      primitives: $props.primitives,
      onDiscountedPrice: $options.updateDiscountedPrice,
      onQuantity: $options.updateQuantity
    }, null, 8, ["price", "shape", "primitives", "onDiscountedPrice", "onQuantity"])
  ]))
}